import { DetailPageActions, DetailPageActionTypes } from '../actions'
import { Reducer } from 'redux'

export type PurchaseDetails = {
  offerToken: string
  failed: boolean
  continueToken?: string
  refTag?: string
} | null

const initialState = null as PurchaseDetails

export const reducer: Reducer<PurchaseDetails, DetailPageActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DetailPageActionTypes.TriggerPurchase:
      // make sure that current purchase is complete before starting a new one
      return state || { ...action.payload, failed: false }
    case DetailPageActionTypes.RESET_STORE:
    case DetailPageActionTypes.PurchaseCancelled:
    case DetailPageActionTypes.RefreshAtfActionBox:
    case DetailPageActionTypes.RefreshBtfActionBoxes:
    case DetailPageActionTypes.RefreshEpisode:
      return null
    case DetailPageActionTypes.PurchaseFailed:
      return action.payload.reload && state ? { ...state, failed: true } : null
    default:
      return state
  }
}
